import React from 'react';

const TreasuryIcon = ({ width = '40', height = '40', fill = '#332B59' }) => (
  <svg fill="{fill}" viewBox="0 -2.78 46 46" xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <path id="_04.Bank" data-name="04.Bank" d="M46,44.438H2a1,1,0,0,1,0-2H46a1,1,0,0,1,0,2Zm-30-10a1,1,0,0,1,0,2H8a1,1,0,0,1,0-2H9v-13H8a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2H15v13Zm-3-13H11v13h2Zm15,13a1,1,0,0,1,0,2H20a1,1,0,0,1,0-2h1v-13H20a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2H27v13Zm-3-13H23v13h2Zm19,18a1,1,0,0,1-1,1H5a1,1,0,0,1,0-2H43A1,1,0,0,1,44,39.438Zm-4-5a1,1,0,0,1,0,2H32a1,1,0,0,1,0-2h1v-13H32a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2H39v13Zm-3-13H35v13h2Zm-34-6L24,4,45,15.438v2H3Zm37.541,0L24,6.886,7.4,15.438Z" transform="translate(-1 -4)" fillRule="evenodd"></path>
    </g>
  </svg>
);

export default TreasuryIcon;




// WEBPACK FOOTER //
// ./src/icons/TreasuryIcon/TreasuryIcon.js